/**
 * @Author: Kerem Koç <keremkoc>
 * @Date:   2018-02-26T02:19:15+03:00
 * @Email:  kerem@kocapps.com
 * @Filename: correct.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-03-02T02:17:13+03:00
 */

(function($, root) {

  $('header .search-button').click(function() {
    $("#myOverlay").fadeIn();
    $("#myOverlay input").focus();

  });
  $("#myOverlay .closebtn,#myOverlay .overlaybg").click(function() {
    $("#myOverlay").fadeOut();
    // $("#myOverlay .overlaybg").hide();

  });

})(jQuery, this);
